import { render, staticRenderFns } from "./Prview.vue?vue&type=template&id=24636074&scoped=true&"
import script from "./Prview.vue?vue&type=script&lang=js&"
export * from "./Prview.vue?vue&type=script&lang=js&"
import style0 from "./Prview.vue?vue&type=style&index=0&id=24636074&scoped=true&lang=css&"
import style1 from "./Prview.vue?vue&type=style&index=1&id=24636074&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24636074",
  null
  
)

export default component.exports